//import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Login from "../components/login/Login";
import App from "../App";
import SignOut from "../components/signOut/SignOut";
import ErrorPage from "../components/errorPage/ErrorPage";
import ClientsPage from "../pages/clients/Clients";
import ColdClientPage from "../pages/coldAccounts/ColdAccounts";
import DepositsPage from "../pages/deposits/Deposits";
import PayoutsPage from "../pages/payouts/Payouts";
import HomePage from "../pages/home/Home";
import SettingsPage from "../pages/settings/Settings";
import TeamsPage from "../pages/teams/Teams";
import TeamPage from "../pages/team/Team";
import EmployeeEditPage from "../pages/employeeEdit/EmployeeEdit";
import ClientEditPage from "../pages/clientEdit/ClientEdit";
import TeamHistory from "../pages/teamHistory/TeamHistory";
import ChangePasswordPage from "../pages/changePassword/changePassword";
import EnterMailPage from "../pages/enterMail/enterMail.jsx";
import DepositTypesPage from "../pages/depositTypes/DepositTypesPage.jsx";
import CampaignsPage from "../pages/campaigns/Campaigns.jsx";
import NewCampaign from "../pages/newCampaign/NewCampaign.jsx";
import CampaignCustomers from "../pages/campaignCustomers/CampaignCustomers.jsx";
import Contract from "../pages/contract/Contract.jsx";
import NewCustomerReportPage from "../pages/newCustomerReport/NewCustomerReport.jsx";
import RenewalReport from "../pages/renewalReport/RenewalReport.jsx";
import CustomerCategoryReportPage from "../pages/customerCategoryReport/CustomerCategoryReport.jsx";
import CustomerCategories from "../pages/customerCategories/CustomerCategories.jsx";
import TemplatesPage from "../pages/templates/Templates.jsx";
import TeamRoles from "../pages/teamRoles/TeamRoles.jsx";
import RoleEditPage from "../pages/roleEdit/RoleEdit.jsx";
import { useSelector } from "react-redux";
import CampaignEditCustomersList from "pages/campaignEditCustomersList/CampaignEditCustomersList";

const ProtectedRoute = ({ children }) => {
  const isLogged = useSelector((state) => state.user.isLogged);

  if (!isLogged) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

/*
const ProtectedRoutePermission = ({
  redirectPath = "/home",
  children,
}) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};
*/

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients",
        element: (
          <ProtectedRoute>
            <ClientsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/:clientId",
        element: (
          <ProtectedRoute>
            <ClientEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/:clientId/:contractId",
        element: (
          <ProtectedRoute>
            <Contract />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/cold",
        element: (
          <ProtectedRoute>
            <ColdClientPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/payments",
        element: (
          <ProtectedRoute>
            <PayoutsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/deposits",
        element: (
          <ProtectedRoute>
            <DepositsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/categories",
        element: (
          <ProtectedRoute>
            <CustomerCategories />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team",
        element: (
          <ProtectedRoute>
            <TeamsPage />
          </ProtectedRoute>
        ),
      },

      {
        path: "/team/history",
        element: (
          <ProtectedRoute>
            <TeamHistory />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team/roles",
        element: (
          <ProtectedRoute>
            <TeamRoles />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team/roles/:roleId",
        element: (
          <ProtectedRoute>
            <RoleEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team/:teamId/:employeeId",
        element: (
          <ProtectedRoute>
            <EmployeeEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/team/:teamId",
        element: (
          <ProtectedRoute>
            <TeamPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/settings",
        element: (
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/templates",
        element: (
          <ProtectedRoute>
            <TemplatesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/campaigns",
        element: (
          <ProtectedRoute>
            <CampaignsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/report/customer-report",
        element: (
          <ProtectedRoute>
            <NewCustomerReportPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/report/renewal",
        element: (
          <ProtectedRoute>
            <RenewalReport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/report/customer-category",
        element: (
          <ProtectedRoute>
            <CustomerCategoryReportPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/campaigns/new",
        element: (
          <ProtectedRoute>
            <NewCampaign />
          </ProtectedRoute>
        ),
      },
      {
        path: "/campaigns/lists",
        element: (
          <ProtectedRoute>
            <CampaignCustomers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/campaigns/lists/:listId",
        element: (
          <ProtectedRoute>
            <CampaignEditCustomersList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/clients/deposit",
        element: (
          <ProtectedRoute>
            <DepositTypesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "sign-out",
        element: (
          <ProtectedRoute>
            <SignOut />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/changePassword",
    element: <ChangePasswordPage />,
  },
  {
    path: "/enterMail",
    element: <EnterMailPage />,
  },
]);
